@if (form) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-card class="evento-tecnico-card">
      <app-card-header
        [title]="data.id ? 'Editar Servicio Técnico' : 'Crear Servicio Técnico'"
        [subtitle]="
          data.id ? '' : 'Completá los pasos para crear un servicio técnico'
        "
        icono="build"
        [botonCerrar]="true"
        (cerrar)="cerrarDialog()"
      ></app-card-header>

      @if (!mostrarResumen()) {
        <mat-card-content class="card-content-crear">
          @if (data.idTracker && !data.id) {
            <div class="form-section">
              <label class="field-label">Crear evento para</label>
              <irx-segmentado
                [value]="tipoEntidad"
                (change)="onTipoEntidadChange($event.value)"
                bloque
              >
                <irx-segmento value="vehiculo" style="flex: 1">
                  <mat-icon>directions_car</mat-icon>
                  Vehículo
                </irx-segmento>
                <irx-segmento value="tracker" style="flex: 1">
                  <mat-icon>gps_fixed</mat-icon>
                  Tracker
                </irx-segmento>
              </irx-segmentado>
            </div>
          }

          <div class="form-pasos-layout">
            <app-pasos-nav
              [stepper]="stepper"
              etiqueta="Pasos del servicio técnico"
            ></app-pasos-nav>

            <mat-stepper #stepper linear class="form-pasos-stepper">
              <!-- Paso 1: Información del Servicio -->
              <mat-step
                [stepControl]="form.controls.valores"
                label="Información del Servicio"
              >
                <app-content-card
                  title="Información del Servicio"
                  icon="build"
                  [formGroup]="form.controls.valores"
                >
                  <!-- Tipo de Servicio -->
                  <div class="form-section">
                    <label class="field-label">Tipo de Servicio</label>
                    <irx-segmentado
                      [formControl]="form.controls.filtrador"
                      bloque
                    >
                      <irx-segmento value="Servicio Técnico" style="flex: 1">
                        <mat-icon>build</mat-icon>
                        Servicio Técnico
                      </irx-segmento>
                      <irx-segmento value="Verificación" style="flex: 1">
                        <mat-icon>search</mat-icon>
                        Verificación
                      </irx-segmento>
                    </irx-segmentado>
                    <mat-hint class="field-hint">
                      @if (
                        form.controls.filtrador.value === 'Servicio Técnico'
                      ) {
                        <mat-icon class="hint-icon">build</mat-icon>
                        <strong>Servicio Técnico:</strong>
                        El técnico puede realizar modificaciones sobre la
                        entidad.
                      } @else {
                        <mat-icon class="hint-icon">search</mat-icon>
                        <strong>Verificación:</strong>
                        El técnico no puede realizar modificaciones sobre la
                        entidad. Solo puede subir fotos y crear notas.
                      }
                    </mat-hint>
                  </div>

                  <!-- Categoría -->
                  @if (form.controls.filtrador.value !== 'Verificación') {
                    <div class="form-section">
                      <label class="field-label">Categoría</label>
                      <app-listado-categoria-selector
                        [idCliente]="cliente?._id ?? null"
                        [categoria]="categoriaTituloActual()"
                        [categorias]="
                          categoriaTituloActual()
                            ? [categoriaTituloActual()!]
                            : null
                        "
                        placeholder="Seleccionar categoría"
                        notFoundText="No hay categorías disponibles"
                        [multiple]="false"
                        [showCrearBtn]="true"
                        [initialNames]="tituloInitialNames"
                        (listadoCategoriaChange)="onTituloChange($event)"
                      ></app-listado-categoria-selector>
                      @if (
                        form.controls.valores.controls.titulo.hasError(
                          'required'
                        ) && form.controls.valores.controls.titulo.touched
                      ) {
                        <mat-error class="field-error">
                          El título es requerido
                        </mat-error>
                      }
                    </div>
                  }

                  <!-- Prioridad -->
                  <div class="form-section">
                    <ng-select
                      formControlName="prioridad"
                      placeholder="Prioridad"
                      [items]="opcionesPrioridad"
                      bindValue="valor"
                      bindLabel="etiqueta"
                      appendTo="body"
                      notFoundText="Sin resultados"
                      style="width: 100%"
                    ></ng-select>
                  </div>

                  <!-- Descripción -->
                  <div class="form-section">
                    <mat-form-field style="width: 100%">
                      <mat-label>Descripción</mat-label>
                      <textarea
                        matInput
                        rows="3"
                        formControlName="mensaje"
                      ></textarea>
                      <mat-icon matPrefix>description</mat-icon>
                    </mat-form-field>
                  </div>
                </app-content-card>
              </mat-step>

              <!-- Paso 2: Datos del Solicitante -->
              <mat-step label="Datos del Solicitante">
                <app-content-card
                  title="Datos del Solicitante"
                  icon="person"
                  [formGroup]="form.controls.valores.controls.solicitante"
                >
                  <div class="form-section inputs-row">
                    <mat-form-field style="width: 100%">
                      <mat-label>Nombre</mat-label>
                      <input matInput formControlName="nombre" />
                      <mat-icon matPrefix>person</mat-icon>
                    </mat-form-field>

                    <mat-form-field style="width: 100%">
                      <mat-label>Teléfono</mat-label>
                      <input matInput formControlName="telefono" />
                      <mat-icon matPrefix>phone</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="form-section">
                    <mat-form-field style="width: 100%">
                      <mat-label>Email</mat-label>
                      <input matInput type="email" formControlName="email" />
                      <mat-icon matPrefix>email</mat-icon>
                      @if (
                        form.controls.valores.controls.solicitante.controls.email.hasError(
                          'email'
                        )
                      ) {
                        <mat-error>El email no es válido</mat-error>
                      }
                    </mat-form-field>
                  </div>
                </app-content-card>
              </mat-step>

              <!-- Paso 3: Disponibilidad Horaria -->
              <mat-step label="Disponibilidad">
                <app-content-card
                  title="Disponibilidad Horaria"
                  icon="date_range"
                  [formGroup]="form.controls.valores"
                >
                  <app-rangos-horarios
                    style="padding: 1em"
                    formControlName="disponibilidad"
                  ></app-rangos-horarios>
                </app-content-card>
              </mat-step>

              <!-- Paso 4: Asignación de Técnico (opcional, en creación y edición) -->
              <mat-step label="Asignación de Técnico">
                <app-content-card
                  title="Asignación de Técnico"
                  icon="engineering"
                  [formGroup]="form.controls.detallesTecnicos"
                >
                  <div class="tecnico-step">
                    <div class="form-section">
                      <label class="field-label">
                        Técnico Asignado
                        @if (!data.id) {
                          <span class="field-optional">(opcional)</span>
                        }
                      </label>
                      <mat-checkbox
                        [(ngModel)]="verTodos"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="cambiarVerTodos()"
                        style="margin-bottom: 8px"
                      >
                        Ver todos los técnicos (no solo los del cliente)
                      </mat-checkbox>
                      <div class="tecnico-selector-row">
                        <ng-select
                          [items]="tecnicosFiltrados"
                          bindValue="_id"
                          bindLabel="label"
                          formControlName="idTecnicoAsignado"
                          placeholder="Seleccionar Técnico"
                          [notFoundText]="'No hay técnicos disponibles'"
                          [multiple]="false"
                          [searchable]="true"
                          appendTo="body"
                          style="flex: 1"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            <div class="tecnico-tag">
                              @if (item.datosPersonales?.foto) {
                                <div
                                  class="tecnico-avatar"
                                  [style.background-image]="
                                    'url(' + item.datosPersonales.foto + ')'
                                  "
                                ></div>
                              }
                              <span class="tecnico-nombre">
                                {{
                                  item.datosPersonales?.nombre || item?.usuario
                                }}
                              </span>
                            </div>
                          </ng-template>

                          <ng-template ng-option-tmp let-item="item">
                            <div class="tecnico-option">
                              @if (item.datosPersonales?.foto) {
                                <div
                                  class="tecnico-avatar"
                                  [style.background-image]="
                                    'url(' + item.datosPersonales.foto + ')'
                                  "
                                ></div>
                              }
                              <span class="tecnico-nombre">
                                {{
                                  item.datosPersonales?.nombre || item?.usuario
                                }}
                              </span>
                            </div>
                          </ng-template>
                        </ng-select>

                        <app-button
                          matType="mat-fab"
                          color="primary"
                          icon="add"
                          [tooltip]="'Crear nuevo técnico'"
                          (click)="onAddTecnico()"
                        ></app-button>
                      </div>
                    </div>

                    <!-- Fecha disponible para tratar (detallesTecnicos) -->
                    <div class="form-section">
                      <label class="field-label">
                        Fecha disponible para tratar
                        <span class="field-optional">(opcional)</span>
                      </label>
                      <mat-form-field
                        style="width: 100%"
                        subscriptSizing="dynamic"
                      >
                        <mat-label>Fecha</mat-label>
                        <input
                          matInput
                          [matDatepicker]="pickerFecha"
                          [(ngModel)]="fechaDisponibleParaTratar"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="DD/MM/YYYY"
                        />
                        <button
                          irxBotonIcono
                          tamano="compacto"
                          matSuffix
                          tooltip="Elegir fecha"
                          (click)="pickerFecha.open()"
                        >
                          <mat-icon>calendar_month</mat-icon>
                        </button>
                        <mat-datepicker #pickerFecha></mat-datepicker>
                      </mat-form-field>
                    </div>

                    @if (tecnicoSeleccionado) {
                      <div class="form-section">
                        <label class="field-label">Materiales asignados</label>
                        @if (materialesTecnico.length) {
                          <div class="materiales-tecnico-lista">
                            @for (m of materialesTecnico; track m.nombre) {
                              <div class="material-item">
                                <span>{{ m.nombre }}</span>
                                <b>×{{ m.cantidad }}</b>
                              </div>
                            }
                          </div>
                        } @else {
                          <p class="materiales-tecnico-vacio">
                            Este técnico no tiene materiales asignados.
                          </p>
                        }
                      </div>

                      <div class="form-section">
                        <button
                          irxBoton="secundario"
                          type="button"
                          (click)="abrirAsignarMateriales()"
                        >
                          <mat-icon>inventory_2</mat-icon>
                          Asignar materiales a este técnico
                        </button>
                      </div>
                    }
                  </div>
                </app-content-card>
              </mat-step>
            </mat-stepper>
          </div>
        </mat-card-content>

        <mat-card-actions class="actions-create">
          <button irxBoton="secundario" type="button" (click)="cerrarDialog()">
            Cancelar
          </button>
          <span class="pie-espacio"></span>
          <button
            irxBoton="secundario"
            type="button"
            (click)="stepper.previous()"
            [disabled]="stepper.selectedIndex === 0"
          >
            <mat-icon>chevron_left</mat-icon>
            Anterior
          </button>
          @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
          <!-- Con el formulario válido, Guardar es la acción principal y
               Siguiente pasa a secundario -->
          @if (!ultimo && form.valid) {
            <button
              irxBoton="secundario"
              type="button"
              (click)="stepper.next()"
            >
              Siguiente
              <mat-icon iconPositionEnd>chevron_right</mat-icon>
            </button>
          } @else if (!ultimo) {
            <button irxBoton="principal" type="button" (click)="stepper.next()">
              Siguiente
              <mat-icon iconPositionEnd>chevron_right</mat-icon>
            </button>
          }
          @if (ultimo || form.valid) {
            <button
              irxBoton="principal"
              type="submit"
              [disabled]="!form.valid || loading()"
            >
              <mat-icon>save</mat-icon>
              Guardar
            </button>
          }
        </mat-card-actions>
      } @else {
        <!-- Resumen -->
        <mat-card-content class="card-content-crear">
          <div class="resumen-container">
            <app-info-banner
              color="green"
              icon="check_circle"
              [title]="
                'Servicio Técnico ' +
                (data.id ? 'Actualizado' : 'Creado') +
                ' Exitosamente'
              "
              [closable]="false"
              margin="0"
            ></app-info-banner>

            @if (asignacionFallida()) {
              <app-info-banner
                color="orange"
                icon="warning"
                title="No se asignó el técnico"
                message="El servicio quedó pendiente y sin técnico. Asignalo desde el listado de servicios técnicos."
                [closable]="false"
                margin="0"
              ></app-info-banner>
            }

            @if (getValoresTecnicos(); as valores) {
              <app-content-card
                title="Código de Incidente"
                icon="confirmation_number"
              >
                <div class="codigo-incidente">
                  {{ valores.numeroIncidente || 'N/A' | uppercase }}
                  <button
                    irxBotonIcono
                    tono="primario"
                    type="button"
                    [copyClipboard]="valores.numeroIncidente || ''"
                    tooltip="Copiar código"
                    class="copy-button"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <p class="codigo-subtitle">
                  Guarde este código para futuras referencias
                </p>
              </app-content-card>

              <app-content-card title="Detalles del Servicio" icon="info">
                <div class="detalle-item">
                  <span class="detalle-label">Título</span>
                  <span class="detalle-value">{{ valores.titulo }}</span>
                </div>
                <div class="detalle-item">
                  <span class="detalle-label">Estado</span>
                  <span class="detalle-value">{{ eventoCreado?.estado }}</span>
                </div>
                <div class="detalle-item">
                  <span class="detalle-label">Prioridad</span>
                  <span class="detalle-value">{{ valores.prioridad }}</span>
                </div>
                @if (valores.solicitante?.nombre) {
                  <div class="detalle-item">
                    <span class="detalle-label">Solicitante</span>
                    <span class="detalle-value">
                      {{ valores.solicitante.nombre }}
                    </span>
                  </div>
                }
              </app-content-card>
            }
          </div>
        </mat-card-content>

        <mat-card-actions class="actions-create">
          <button irxBoton="principal" type="button" (click)="cerrarDialog()">
            Cerrar
          </button>
        </mat-card-actions>
      }
    </mat-card>
  </form>
}
